/**
 * analytics.js
 * Unified event tracking — fires to both GA4 (gtag) and Vercel Analytics.
 * Guards against gtag not being loaded (e.g. during local dev with no network).
 */

import { track } from '@vercel/analytics'

/**
 * Track a custom event on both GA4 and Vercel Analytics.
 * @param {string} eventName - The event name (snake_case recommended)
 * @param {Object} params    - Optional event parameters
 */
export function trackEvent(eventName, params = {}) {
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, params)
  }
  track(eventName, params)
}